import { lazyLoad } from 'utils/loadable';

export const AccountLayout = lazyLoad(
  () => import('./index'),
  module => module.AccountLayout,
);
